import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { type FeaturedMosaicItemBlock } from '@module/mdrt-org/shared/utils/data/graphql/_generated/gql-generated';
import { FeaturedMosaicColors } from '../../utils/featured-mosaic-colors';
import { FeaturedMosaicOverlayStrengths } from '../../utils/featured-mosaic-overlay-strengths';
import { FeaturedMosaicTextThemes } from '../../utils/featured-mosaic-text-themes';
import styles from '../../featured-mosaic-container-block.module.scss';
export type FeaturedMosaicItemProps = {
  blockData: FeaturedMosaicItemBlock;
};
export const FeaturedMosaicItem = t0 => {
  const $ = _c(37);
  const {
    blockData
  } = t0;
  const t1 = blockData.FeaturedLink ?? "";
  const t2 = blockData.LinkTarget ?? "_self";
  const t3 = blockData.BackgroundImage?.AltText || "";
  const t4 = blockData.BackgroundImage?.ImageReference?.Url || "";
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = <Image alt={t3} className={styles["featured-mosaic-background__image"]} fill={true} sizes="(min-width: 768px) 50vw, 100vw" src={t4} />;
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== blockData.OverlayColor || $[4] !== blockData.OverlayStrength) {
    t6 = classNames(styles["featured-mosaic-background__overlay"], {
      [styles["featured-mosaic-background__overlay--blue"]]: blockData.OverlayColor === FeaturedMosaicColors.Blue,
      [styles["featured-mosaic-background__overlay--green"]]: blockData.OverlayColor === FeaturedMosaicColors.Green,
      [styles["featured-mosaic-background__overlay--purple"]]: blockData.OverlayColor === FeaturedMosaicColors.Purple,
      [styles["featured-mosaic-background__overlay--red"]]: blockData.OverlayColor === FeaturedMosaicColors.Red,
      [styles["featured-mosaic-background__overlay--yellow"]]: blockData.OverlayColor === FeaturedMosaicColors.Yellow
    }, {
      [styles["featured-mosaic-background__overlay--light"]]: blockData.OverlayStrength === FeaturedMosaicOverlayStrengths.Light,
      [styles["featured-mosaic-background__overlay--medium"]]: blockData.OverlayStrength === FeaturedMosaicOverlayStrengths.Medium,
      [styles["featured-mosaic-background__overlay--strong"]]: blockData.OverlayStrength === FeaturedMosaicOverlayStrengths.Strong
    });
    $[3] = blockData.OverlayColor;
    $[4] = blockData.OverlayStrength;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <div className={t6} />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t7) {
    t8 = <div className={styles["featured-mosaic-background"]}>{t5}{t7}</div>;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = blockData.TextTheme === FeaturedMosaicTextThemes.Dark;
  const t10 = blockData.TextTheme === FeaturedMosaicTextThemes.Light;
  let t11;
  if ($[11] !== t10 || $[12] !== t9) {
    t11 = classNames(styles["featured-mosaic-content"], {
      [styles["featured-mosaic-content--dark-text"]]: t9,
      [styles["featured-mosaic-content--light-text"]]: t10
    });
    $[11] = t10;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = blockData.PillColor === FeaturedMosaicColors.Blue;
  const t13 = blockData.PillColor === FeaturedMosaicColors.Green;
  const t14 = blockData.PillColor === FeaturedMosaicColors.Purple;
  const t15 = blockData.PillColor === FeaturedMosaicColors.Red;
  const t16 = blockData.PillColor === FeaturedMosaicColors.Yellow;
  let t17;
  if ($[14] !== t12 || $[15] !== t13 || $[16] !== t14 || $[17] !== t15 || $[18] !== t16) {
    t17 = classNames(styles["featured-mosaic-content__pill"], {
      [styles["featured-mosaic-content__pill--blue"]]: t12,
      [styles["featured-mosaic-content__pill--green"]]: t13,
      [styles["featured-mosaic-content__pill--purple"]]: t14,
      [styles["featured-mosaic-content__pill--red"]]: t15,
      [styles["featured-mosaic-content__pill--yellow"]]: t16
    });
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  const t18 = blockData.PillText || "";
  let t19;
  if ($[20] !== t17 || $[21] !== t18) {
    t19 = <p className={t17}>{t18}</p>;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  const t20 = blockData.Title || "";
  let t21;
  if ($[23] !== t20) {
    t21 = <h3 className={styles["featured-mosaic-content__title"]}>{t20}</h3>;
    $[23] = t20;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  const t22 = blockData.Description || "";
  let t23;
  if ($[25] !== t22) {
    t23 = <p className={styles["featured-mosaic-content__description"]}><span className={styles["featured-mosaic-content__description__text"]}>{t22}</span></p>;
    $[25] = t22;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t11 || $[28] !== t19 || $[29] !== t21 || $[30] !== t23) {
    t24 = <div className={t11}>{t19}{t21}{t23}</div>;
    $[27] = t11;
    $[28] = t19;
    $[29] = t21;
    $[30] = t23;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] !== t1 || $[33] !== t2 || $[34] !== t24 || $[35] !== t8) {
    t25 = <div className={styles["featured-mosaic-item"]}><Link href={t1} target={t2}>{t8}{t24}</Link></div>;
    $[32] = t1;
    $[33] = t2;
    $[34] = t24;
    $[35] = t8;
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  return t25;
};